module.exports = __webpack_public_path__ + "img/Male_Posterior_PaperDoll.4e650f31.png";